/**
 * Crea el boton de borrar apuesta
 * @param {*} scene
 */
export function crearBotonBorrar(scene) {
  scene.botonBorrar = scene.add.image(698, 470, 'botonBorrar').setInteractive();

  scene.botonBorrar.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonBorrar.setTexture('botonBorrarHover');
    }
  });

  scene.botonBorrar.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonBorrar.setTexture('botonBorrar');
    }
  });

  scene.botonBorrar.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonBorrar.setTexture('botonBorrarPressed');
    }
  });

  scene.botonBorrar.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonBorrar.input?.isOver) {
        scene.botonBorrar.setTexture('botonBorrar');
      } else {
        scene.botonBorrar.setTexture('botonBorrarHover');
        scene.borrarApuesta();
      }
    }
  });
}
